/**
 * 音频流播放器包装类
 */
import { SimpleAudioPlayer } from './SimpleAudioPlayer.js';

export class AudioStreamPlayer {
  constructor(options = {}) {
    this.player = new SimpleAudioPlayer({
      sampleRate: options.sampleRate || 16000,
      channels: options.channels || 1,
      volume: options.volume || 1,
      playbackRate: options.playbackRate || 1.0,
      fadeDuration: options.fadeDuration || 50,
      filterFrequency: options.filterFrequency || 8000,
      smallChunkThreshold: options.smallChunkThreshold || 5000,
      onStatusUpdate: options.onStatusUpdate || (() => {}),
      onPlaybackComplete: options.onPlaybackComplete || (() => {}),
    });
    
    // 确保初始化为暂停状态
    this.player.isPaused = true;
    this.player.isPlaying = false;
  }

  // 代理所有方法到内部播放器
  playBase64Audio(base64Data) {
    return this.player.playBase64Audio(base64Data);
  }

  addPCMData(pcmData) {
    return this.player.addPCMData(pcmData);
  }

  pause() {
    return this.player.pause();
  }

  resume() {
    return this.player.resume();
  }

  replay() {
    return this.player.replay();
  }

  stop() {
    return this.player.stop();
  }

  getStatus() {
    return this.player.getStatus();
  }

  hasAudioData() {
    return this.player.hasAudioData();
  }

  setVolume(volume) {
    return this.player.setVolume(volume);
  }

  // 兼容性方法
  get gainNode() {
    return this.player.gainNode;
  }

  get volume() {
    return this.player.volume;
  }

  initAudioContext() {
    // 已在构造函数中初始化
    return this.player.audioContext;
  }
}